import { GridInitialState } from "../../Unknown/DataGrid";

export const initialGridState: GridInitialState = {
  sorting: { sortModel: [{ field: "uploadedAt", sort: "desc" }] },
};
